(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1996],{

/***/ 65988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ Accordion; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49642);
/* harmony import */ var _components_elements_Spacer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1253);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);







var Accordion = function Accordion(_ref) {
  var accordionTitle = _ref.accordionTitle,
      children = _ref.children,
      contentsLength = _ref.contentsLength,
      _ref$isDefaultOpen = _ref.isDefaultOpen,
      isDefaultOpen = _ref$isDefaultOpen === void 0 ? false : _ref$isDefaultOpen;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(isDefaultOpen),
      isExpand = _useState[0],
      setIsExpand = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),
      childHeight = _useState2[0],
      setChildHeight = _useState2[1];

  var childElement = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (childElement.current) {
      var _childElement$current;

      var height = (_childElement$current = childElement.current) === null || _childElement$current === void 0 ? void 0 : _childElement$current.clientHeight;
      setChildHeight(height);
    }
  }, []);

  var handleClick = function handleClick() {
    if (childElement.current) {
      setIsExpand(!isExpand);
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(AccordionTitle, {
      onClick: handleClick,
      children: [contentsLength > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Icon, {
        isExpand: isExpand
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Title, {
        children: accordionTitle
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_elements_Spacer__WEBPACK_IMPORTED_MODULE_2__/* .Spacer */ .L, {
      h: {
        sp: 10,
        pc: 18
      }
    }), contentsLength === 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(NoItemText, {
      children: "\u305F\u3060\u3044\u307E\u63B2\u8F09\u3059\u3079\u304D\u4E8B\u9805\u306F\u3054\u3056\u3044\u307E\u305B\u3093\u3002"
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(AccordionItems, {
      isExpand: isExpand,
      childHeight: childHeight,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        ref: childElement,
        children: children
      })
    })]
  });
};
var AccordionTitle = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Accordion__AccordionTitle",
  componentId: "sc-1afnqmj-0"
})(["display:flex;align-items:center;gap:10px;&:hover{cursor:pointer;> h4{color:", ";}}@media screen and (max-width:1047px){align-items:flex-start;gap:6px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.lightBlue */ .r.colors.lightBlue);
var Title = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].h4.withConfig */ .ZP.h4.withConfig({
  displayName: "Accordion__Title",
  componentId: "sc-1afnqmj-1"
})(["font-size:24px;font-weight:bold;color:", ";line-height:33.6px;@media screen and (max-width:1047px){font-size:18px;line-height:23.4px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue);
var NoItemText = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "Accordion__NoItemText",
  componentId: "sc-1afnqmj-2"
})(["font-size:16px;line-height:25.6px;color:", ";@media screen and (max-width:1047px){font-size:15px;line-height:24px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.textTitle */ .r.colors.textTitle);
var AccordionItems = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Accordion__AccordionItems",
  componentId: "sc-1afnqmj-3"
})(["height:", ";opacity:", ";transition:height 0.2s linear,opacity 0.5s ease-in;overflow:hidden;"], function (_ref2) {
  var isExpand = _ref2.isExpand,
      childHeight = _ref2.childHeight;
  return isExpand ? "".concat(childHeight, "px") : '0px';
}, function (_ref3) {
  var isExpand = _ref3.isExpand;
  return isExpand ? 1 : 0;
});
var Icon = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "Accordion__Icon",
  componentId: "sc-1afnqmj-4"
})(["transition:all 0.25s ease;overflow:hidden;position:relative;padding-top:2px;padding-right:10px;width:40px;height:40px;&::before,&::after{content:'';display:inline-block;width:30px;height:4px;position:absolute;top:50%;background-image:url('/images/accordion.png');}&::after{transform:rotate(90deg);transition:transform 0.4s ease;}", " @media screen and (max-width:1047px){padding-top:7px;padding-right:16px;width:16px;height:23px;&::before,&::after{width:16px;height:2.13px;}}"], function (_ref4) {
  var isExpand = _ref4.isExpand;
  return isExpand ? (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["&::after{transform:rotate(0);}"]) : '';
});

/***/ }),

/***/ 33784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ ChartAnnotation; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);


var ChartAnnotation = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "ChartAnnotation",
  componentId: "sc-1fwykuv-0"
})(["font-size:12px;color:", ";line-height:1.9;@media screen and (max-width:1047px){font-size:11px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textSecond */ .r.colors.textSecond);

/***/ }),

/***/ 97071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ PDFIcon; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/elements/Icon/PDF/pdf.svg
var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgPdf = function SvgPdf(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 24"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1777"
  }, /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1540",
    d: "M5.963 5.234V.291L.278 5.976h4.943c.534 0 .742-.208.742-.742Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1541",
    d: "M8.819 11.945a8.259 8.259 0 0 0 .414-1.759c.207-1.008-.052-1.629-.594-1.55s-.672.7-.62 1.344a5.342 5.342 0 0 0 .594 1.784s.1.258.206.181Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1542",
    d: "M6.339 17.118a5.839 5.839 0 0 0-2.041 1.086c-.7.673-.648 1.267-.336 1.473s1.189-.414 1.732-1.06a5.145 5.145 0 0 0 .9-1.4c.004-.099-.047-.177-.255-.099Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1543",
    d: "M8.214 16.028c.515-.206 2.377-.621 2.377-.621s-1.214-1.447-1.37-1.732c0 .001-.724 1.888-1.007 2.353Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1544",
    d: "M17.051 0H6.97v5.864a1.171 1.171 0 0 1-1.164 1.174H0v16a.955.955 0 0 0 .949.957h16.1a.954.954 0 0 0 .949-.957V.956A.954.954 0 0 0 17.051 0Zm-3.106 17.849a7.087 7.087 0 0 1-2.917-1.886.23.23 0 0 0-.069-.015c-.15 0-1.82.485-3.088.848-1.854 3.341-3.7 4.294-4.567 3.189-.456-.582-.28-1.955 1.914-2.984a14.164 14.164 0 0 1 1.77-.668 31.5 31.5 0 0 0 1.573-3.579 10.185 10.185 0 0 1-1.072-2.772c-.1-1.081.357-2.059 1.276-2.059 1.171 0 2.04 1.132.668 5.111a12.589 12.589 0 0 0 1.673 2.246 13.561 13.561 0 0 1 2.784-.261c1.651.1 1.994.877 2.045 1.469a1.6 1.6 0 0 1-1.99 1.361Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1545",
    d: "M13.761 15.555a6.219 6.219 0 0 0-2.069.258 6.871 6.871 0 0 0 2.093 1.035c.777.1 1.062-.232 1.062-.568s-.284-.673-1.086-.725Z"
  }))));
};
/* harmony default export */ var pdf = (SvgPdf);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/elements/Icon/PDF/index.tsx


var _excluded = ["size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var PDFIcon = function PDFIcon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'regular' : _ref$size,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledIcon, _objectSpread(_objectSpread({}, props), {}, {
    "data-size": size
  }));
};
var StyledIcon = (0,styled_components_browser_esm/* default */.ZP)(pdf).withConfig({
  displayName: "PDF__StyledIcon",
  componentId: "sc-18bayee-0"
})(["transition:fill 0.3s ease;fill:", ";&[data-size='regular']{width:18px;height:24px;}&[data-size='small']{width:12px;height:28px;}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue);

/***/ }),

/***/ 55919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Td": function() { return /* binding */ Td; },
/* harmony export */   "Th": function() { return /* binding */ Th; },
/* harmony export */   "Tr": function() { return /* binding */ Tr; },
/* harmony export */   "hr": function() { return /* binding */ Thead; },
/* harmony export */   "iA": function() { return /* binding */ Table; },
/* harmony export */   "p3": function() { return /* binding */ Tbody; },
/* harmony export */   "wA": function() { return /* binding */ TbodyWithThreeColumnHeadings; }
/* harmony export */ });
/* unused harmony export TbodyWithTwoColumnHeadings */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



var Table = function Table(_ref) {
  var labelId = _ref.labelId,
      label = _ref.label,
      children = _ref.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TableWrapper, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTable, {
      "aria-labelledby": labelId,
      "aria-label": label,
      children: children
    })
  });
};
var TableWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Table__TableWrapper",
  componentId: "sc-173bbn3-0"
})(["overflow-y:auto;"]);
var StyledTable = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].table.withConfig */ .ZP.table.withConfig({
  displayName: "Table__StyledTable",
  componentId: "sc-173bbn3-1"
})(["border-collapse:separate;width:100%;"]);
var Thead = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].thead.withConfig */ .ZP.thead.withConfig({
  displayName: "Table__Thead",
  componentId: "sc-173bbn3-2"
})(["> tr:first-of-type > th:first-of-type{position:sticky;left:0;border-left:1px solid ", ";}> tr:first-of-type > th{border-top:1px solid ", ";}> tr > th{word-break:keep-all;&.AnalystCoverage{word-break:normal;}}tr > th:first-of-type{border-left:1px solid ", ";}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.tableBorder */ .r.colors.tableBorder, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.tableBorder */ .r.colors.tableBorder, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.tableBorder */ .r.colors.tableBorder);
var Tbody = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].tbody.withConfig */ .ZP.tbody.withConfig({
  displayName: "Table__Tbody",
  componentId: "sc-173bbn3-3"
})(["> tr > th{border-left:1px solid ", ";}> tr > th:first-of-type{position:sticky;left:0;}> tr > td:last-of-type{border-right:1px solid ", ";}@media screen and (max-width:1047px){> tr > th{min-width:30vw;}}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.tableBorder */ .r.colors.tableBorder, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.tableBorder */ .r.colors.tableBorder);
var TbodyWithTwoColumnHeadings = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].tbody.withConfig */ .ZP.tbody.withConfig({
  displayName: "Table__TbodyWithTwoColumnHeadings",
  componentId: "sc-173bbn3-4"
})(["> tr > th:first-of-type{position:sticky;left:", ";}> tr > th[rowspan]{border-left:1px solid ", ";position:sticky;left:0;min-width:", ";}> tr > th[rowspan] + th{position:sticky;left:", ";}@media screen and (max-width:1047px){> tr > th[rowspan] + th{min-width:14vw;position:sticky;}}&.StickyItem{position:sticky;top:0;z-index:10;}"], function (_ref2) {
  var firstHeadWidth = _ref2.firstHeadWidth;
  return firstHeadWidth;
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.tableBorder */ .r.colors.tableBorder, function (_ref3) {
  var firstHeadWidth = _ref3.firstHeadWidth;
  return firstHeadWidth;
}, function (_ref4) {
  var firstHeadWidth = _ref4.firstHeadWidth;
  return firstHeadWidth;
});
var TbodyWithThreeColumnHeadings = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].tbody.withConfig */ .ZP.tbody.withConfig({
  displayName: "Table__TbodyWithThreeColumnHeadings",
  componentId: "sc-173bbn3-5"
})(["> tr > th:nth-last-of-type(1){min-width:85px;position:sticky;left:calc(", " + ", ");}> tr > th:nth-last-of-type(2){width:", ";min-width:", ";position:sticky;left:", ";border-left:1px solid ", ";}> tr > th:nth-last-of-type(3){width:", ";min-width:", ";position:sticky;left:0px;border-left:1px solid ", ";}@media screen and (max-width:1047px){> tr > th:nth-last-of-type(1){min-width:14vw;position:sticky;}}&.StickyItem{position:sticky;top:0;z-index:10;}"], function (_ref5) {
  var firstHeadWidth = _ref5.firstHeadWidth;
  return firstHeadWidth;
}, function (_ref6) {
  var secondHeadWidth = _ref6.secondHeadWidth;
  return secondHeadWidth || '0px';
}, function (_ref7) {
  var secondHeadWidth = _ref7.secondHeadWidth;
  return secondHeadWidth || '60px';
}, function (_ref8) {
  var secondHeadWidth = _ref8.secondHeadWidth;
  return secondHeadWidth || '60px';
}, function (_ref9) {
  var firstHeadWidth = _ref9.firstHeadWidth;
  return firstHeadWidth;
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.tableBorder */ .r.colors.tableBorder, function (_ref10) {
  var firstHeadWidth = _ref10.firstHeadWidth;
  return firstHeadWidth;
}, function (_ref11) {
  var firstHeadWidth = _ref11.firstHeadWidth;
  return firstHeadWidth;
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.tableBorder */ .r.colors.tableBorder);
var Tr = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].tr.withConfig */ .ZP.tr.withConfig({
  displayName: "Table__Tr",
  componentId: "sc-173bbn3-6"
})([""]);
var Th = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].th.withConfig */ .ZP.th.withConfig({
  displayName: "Table__Th",
  componentId: "sc-173bbn3-7"
})(["padding:13px 5px 15px 5px;font-size:16px;text-align:", ";vertical-align:middle;border-right:", ";border-bottom:1px solid ", ";line-height:1.2;background:", ";@media screen and (max-width:1047px){padding:10px 12px 12px 12px;font-size:15px;}> tr > th[rowspan] + th{position:sticky;left:", ";}font-weight:", ";"], function (_ref12) {
  var textAlign = _ref12.textAlign;
  return textAlign !== null && textAlign !== void 0 ? textAlign : 'center';
}, function (_ref13) {
  var noBorder = _ref13.noBorder;
  return noBorder ? 'none' : "1px solid ".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.tableBorder */ .r.colors.tableBorder);
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.tableBorder */ .r.colors.tableBorder, function (_ref14) {
  var color = _ref14.color;
  return color === 'primary' ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.th.primary */ .r.colors.th.primary : color === 'secondary' ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.th.secondary */ .r.colors.th.secondary : color === 'darkest' ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.th.darkest */ .r.colors.th.darkest : color === 'accentYellow' ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.th.accentYellow */ .r.colors.th.accentYellow : color === 'holiday' ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.th.accentYellow */ .r.colors.th.accentYellow : color === 'tertiary' ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.th.tertiary */ .r.colors.th.tertiary : color === 'quaternary' ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.th.quaternary */ .r.colors.th.quaternary : _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.th["default"] */ .r.colors.th["default"];
}, function (_ref15) {
  var firstHeadWidth = _ref15.firstHeadWidth;
  return firstHeadWidth;
}, function (_ref16) {
  var isBold = _ref16.isBold;
  return isBold ? 'bold' : 'normal';
});
var Td = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].td.withConfig */ .ZP.td.withConfig({
  displayName: "Table__Td",
  componentId: "sc-173bbn3-8"
})(["padding:13px 5px 15px 5px;font-size:16px;line-height:1.2;text-align:", ";background:", ";vertical-align:middle;border-right:", ";border-bottom:1px solid ", ";@media screen and (max-width:1047px){padding:10px 12px 12px 12px;font-size:15px;}"], function (_ref17) {
  var textAlign = _ref17.textAlign;
  return textAlign !== null && textAlign !== void 0 ? textAlign : 'right';
}, function (_ref18) {
  var color = _ref18.color;
  return color === 'primary' ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.th.primary */ .r.colors.th.primary : color === 'secondary' ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.th.secondary */ .r.colors.th.secondary : _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.td["default"] */ .r.colors.td["default"];
}, function (_ref19) {
  var noBorder = _ref19.noBorder;
  return noBorder ? 'none' : "1px solid ".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.tableBorder */ .r.colors.tableBorder);
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.tableBorder */ .r.colors.tableBorder);

/***/ }),

/***/ 24604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ PDFItem; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var _utils_date__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16645);
/* harmony import */ var _components_elements_Icon_PDF__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97071);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






var PDFItem = function PDFItem(_ref) {
  var date = _ref.date,
      fileName = _ref.fileName,
      filePath = _ref.filePath;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(StyledLink, {
    href: filePath,
    target: "_blank",
    rel: "noreferrer noopener",
    children: [date && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Time, {
      dateTime: date,
      children: (0,_utils_date__WEBPACK_IMPORTED_MODULE_3__/* .formatDate */ .p6)(date, 'yyyy/MM/dd')
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Icon, {
      size: "small"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Name, {
      children: fileName
    })]
  });
};
var Time = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].time.withConfig */ .ZP.time.withConfig({
  displayName: "PDFItem__Time",
  componentId: "sc-12039hs-0"
})(["font-weight:700;line-height:1.6;"]);
var StyledLink = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].a.withConfig */ .ZP.a.withConfig({
  displayName: "PDFItem__StyledLink",
  componentId: "sc-12039hs-1"
})(["transition:color 0.3s ease;display:flex;align-items:center;gap:10px;padding-top:18px;padding-bottom:20px;width:100%;&:hover{> span{color:", ";text-decoration:underline;}> svg{fill:", ";}}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.lightBlue */ .r.colors.lightBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.lightBlue */ .r.colors.lightBlue);
var Name = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "PDFItem__Name",
  componentId: "sc-12039hs-2"
})(["line-height:1.6;"]);
var Icon = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_components_elements_Icon_PDF__WEBPACK_IMPORTED_MODULE_1__/* .PDFIcon */ .H).withConfig({
  displayName: "PDFItem__Icon",
  componentId: "sc-12039hs-3"
})(["flex-shrink:0;"]);

/***/ }),

/***/ 16653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ PDFList; }
/* harmony export */ });
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49642);
/* harmony import */ var _PDFItem__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24604);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var PDFList = function PDFList(_ref) {
  var pdfList = _ref.pdfList;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("ul", {
    children: pdfList.map(function (pdf) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Item, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_PDFItem__WEBPACK_IMPORTED_MODULE_2__/* .PDFItem */ .G, _objectSpread({}, pdf))
      }, pdf.id);
    })
  });
};
var Item = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].li.withConfig */ .ZP.li.withConfig({
  displayName: "PDFList__Item",
  componentId: "sc-mppgtj-0"
})(["display:flex;align-items:center;:not(:last-child){border-bottom:1px solid ", ";}"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.backgroundBlue */ .r.colors.backgroundBlue);

/***/ }),

/***/ 7257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useMediaQuery; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useMediaQuery = function useMediaQuery(mediaQuery) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      isMatch = _useState[0],
      setIsMatch = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var mediaQueryList = window.matchMedia(mediaQuery);

    var documentChangeHandler = function documentChangeHandler() {
      setIsMatch(mediaQueryList.matches);
    };

    mediaQueryList.addEventListener('change', documentChangeHandler);
    documentChangeHandler();
    return function () {
      mediaQueryList.removeEventListener('change', documentChangeHandler);
    };
  }, [mediaQuery]);
  return isMatch;
};

/***/ }),

/***/ 777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* reexport */ MonthlySalesPage; }
});

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/components/elements/Accordion/index.tsx
var Accordion = __webpack_require__(65988);
// EXTERNAL MODULE: ./src/components/layouts/Ir/Heading.tsx
var Heading = __webpack_require__(82592);
// EXTERNAL MODULE: ./src/components/layouts/Ir/PDFList.tsx
var PDFList = __webpack_require__(16653);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/Ir/Financial/MonthlySales/Pdffiles.tsx







var MonthlySalesPDF = function MonthlySalesPDF(_ref) {
  var yearsPdf = _ref.yearsPdf;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* AHeading */.Os, {
      children: "\u6708\u6B21\u58F2\u4E0A\u9AD8\u901F\u5831 PDF\u8CC7\u6599\u4E00\u89A7"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Section, {
      children: yearsPdf.map(function (value, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Accordion/* Accordion */.U, {
            accordionTitle: value.accordionTitle,
            contentsLength: value.accordionItems.length,
            isDefaultOpen: value.isDefaultOpen,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(PDFList/* PDFList */.T, {
              pdfList: value.accordionItems
            })
          })
        }, "".concat(index).concat(value.accordionTitle));
      })
    })]
  });
};
var Section = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "Pdffiles__Section",
  componentId: "sc-18v2uzy-0"
})(["display:flex;flex-direction:column;gap:50px;"]);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./src/utils/date.ts
var date = __webpack_require__(16645);
// EXTERNAL MODULE: ./src/components/elements/ChartAnnotation/index.tsx
var ChartAnnotation = __webpack_require__(33784);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/components/elements/Table/index.tsx
var Table = __webpack_require__(55919);
// EXTERNAL MODULE: ./src/components/layouts/Ir/Paragraph.tsx
var Paragraph = __webpack_require__(45775);
// EXTERNAL MODULE: ./src/hooks/useMediaQuery.ts
var useMediaQuery = __webpack_require__(7257);
;// CONCATENATED MODULE: ./src/components/pages/Ir/Financial/MonthlySales/Table.tsx














var dayNumberToEnglish = function dayNumberToEnglish(dayNumber) {
  // dayNumberが1桁かつ10の位が0の場合
  if (dayNumber.length === 2 && dayNumber[0] === '0') {
    // 一の位の数字のみを取り出す
    return dayNumber[1]; // 先頭の0を除去して返す
  }

  return dayNumber;
};

var MonthlySalesTable = function MonthlySalesTable(_ref) {
  var _monthlySales$fullYea, _monthlySales$fullYea2, _monthlySales$fullYea3, _monthlySales$fullYea4, _monthlySales$fullYea5, _monthlySales$fullYea6, _monthlySales$fullYea7, _monthlySales$fullYea8;

  var monthlySales = _ref.monthlySales;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* AHeading */.Os, {
      children: monthlySales.titleJA
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
      children: "\u6BCE\u670810\u65E5\u9803\u306B\u66F4\u65B0\u4E88\u5B9A\u3067\u3059\u3002"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 10,
        pc: 20
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PublicationDate, {
      children: [(0,date/* formatDate */.p6)(monthlySales.newpublicationDate, 'yyyy年'), dayNumberToEnglish((0,date/* formatDate */.p6)(monthlySales.newpublicationDate, 'MM月')), dayNumberToEnglish((0,date/* formatDate */.p6)(monthlySales.newpublicationDate, 'dd日')), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "(\u524D\u5E74\u540C\u6708\u6BD4\uFF1A\uFF05)"]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 10,
        pc: 20
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Table/* Table */.iA, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Table/* Thead */.hr, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Table.Tr, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Table.Th, {
                rowSpan: 2,
                colSpan: 3
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Table.Th, {
                colSpan: 9,
                color: 'secondary',
                children: monthlySales.fHyear
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Table.Th, {
                colSpan: 9,
                color: 'secondary',
                children: monthlySales.sHyear
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Table.Th, {
                rowSpan: 2,
                color: 'secondary',
                children: "\u901A\u671F"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Table.Tr, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Table.Th, {
                color: "quaternary",
                children: "7\u6708"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Table.Th, {
                color: "quaternary",
                children: "8\u6708"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Table.Th, {
                color: "quaternary",
                children: "9\u6708"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(QuarterTh, {
                color: "tertiary",
                children: "1Q"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Table.Th, {
                color: "quaternary",
                children: "10\u6708"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Table.Th, {
                color: "quaternary",
                children: "11\u6708"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Table.Th, {
                color: "quaternary",
                children: "12\u6708"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(QuarterTh, {
                color: "tertiary",
                children: "2Q"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Table.Th, {
                color: "secondary",
                children: "\u4E0A\u671F"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Table.Th, {
                color: "quaternary",
                children: "1\u6708"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Table.Th, {
                color: "quaternary",
                children: "2\u6708"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Table.Th, {
                color: "quaternary",
                children: "3\u6708"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(QuarterTh, {
                color: "tertiary",
                children: "3Q"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Table.Th, {
                color: "quaternary",
                children: "4\u6708"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Table.Th, {
                color: "quaternary",
                children: "5\u6708"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Table.Th, {
                color: "quaternary",
                children: "6\u6708"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(QuarterTh, {
                color: "tertiary",
                children: "4Q"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Table.Th, {
                color: "secondary",
                children: "\u4E0B\u671F"
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Table/* TbodyWithThreeColumnHeadings */.wA, {
            firstHeadWidth: "35px",
            secondHeadWidth: "35px",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Table.Tr, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Table.Th, {
                rowSpan: 7,
                noBorder: true,
                style: {
                  whiteSpace: 'nowrap'
                },
                children: ["\u30C8", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u30E9", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u30A4", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u30A2", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u30EB"]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Table.Th, {
                rowSpan: 3,
                style: {
                  whiteSpace: 'nowrap'
                },
                children: ["\u65E2", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u5B58", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u5E97"]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTh, {
                children: "\u58F2\u4E0A\u9AD8"
              }), monthlySales.fH.map(function (Sales, index) {
                var _Sales$oShopSales;

                return /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                  children: (_Sales$oShopSales = Sales.oShopSales) !== null && _Sales$oShopSales !== void 0 ? _Sales$oShopSales : ' '
                }, "".concat(Sales).concat(index));
              }), monthlySales.sH.map(function (Sales, index) {
                var _Sales$oShopSales2;

                return /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                  children: (_Sales$oShopSales2 = Sales.oShopSales) !== null && _Sales$oShopSales2 !== void 0 ? _Sales$oShopSales2 : ' '
                }, "".concat(Sales).concat(index));
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                children: (_monthlySales$fullYea = monthlySales.fullYear.oShopSales) !== null && _monthlySales$fullYea !== void 0 ? _monthlySales$fullYea : ' '
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Table.Tr, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SmallTh, {
                children: "\u5BA2\u6570"
              }), monthlySales.fH.map(function (Sales, index) {
                var _Sales$oShopCustomers;

                return /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                  children: (_Sales$oShopCustomers = Sales.oShopCustomers) !== null && _Sales$oShopCustomers !== void 0 ? _Sales$oShopCustomers : ' '
                }, "".concat(Sales).concat(index));
              }), monthlySales.sH.map(function (Sales, index) {
                var _Sales$oShopCustomers2;

                return /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                  children: (_Sales$oShopCustomers2 = Sales.oShopCustomers) !== null && _Sales$oShopCustomers2 !== void 0 ? _Sales$oShopCustomers2 : ' '
                }, "".concat(Sales).concat(index));
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                children: (_monthlySales$fullYea2 = monthlySales.fullYear.oShopCustomers) !== null && _monthlySales$fullYea2 !== void 0 ? _monthlySales$fullYea2 : ' '
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Table.Tr, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SmallTh, {
                children: "\u5BA2\u5358\u4FA1"
              }), monthlySales.fH.map(function (Sales, index) {
                var _Sales$oShopCustomerU;

                return /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                  children: (_Sales$oShopCustomerU = Sales.oShopCustomerUnitPrice) !== null && _Sales$oShopCustomerU !== void 0 ? _Sales$oShopCustomerU : ' '
                }, "".concat(Sales).concat(index));
              }), monthlySales.sH.map(function (Sales, index) {
                var _Sales$oShopCustomerU2;

                return /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                  children: (_Sales$oShopCustomerU2 = Sales.oShopCustomerUnitPrice) !== null && _Sales$oShopCustomerU2 !== void 0 ? _Sales$oShopCustomerU2 : ' '
                }, "".concat(Sales).concat(index));
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                children: (_monthlySales$fullYea3 = monthlySales.fullYear.oShopCustomerUnitPrice) !== null && _monthlySales$fullYea3 !== void 0 ? _monthlySales$fullYea3 : ' '
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Table.Tr, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Table.Th, {
                rowSpan: 4,
                style: {
                  whiteSpace: 'nowrap'
                },
                children: ["\u5168", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u5E97"]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTh, {
                children: "\u58F2\u4E0A\u9AD8"
              }), monthlySales.fH.map(function (Sales, index) {
                var _Sales$aShopSales;

                return /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                  children: (_Sales$aShopSales = Sales.aShopSales) !== null && _Sales$aShopSales !== void 0 ? _Sales$aShopSales : ' '
                }, "".concat(Sales).concat(index));
              }), monthlySales.sH.map(function (Sales, index) {
                var _Sales$aShopSales2;

                return /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                  children: (_Sales$aShopSales2 = Sales.aShopSales) !== null && _Sales$aShopSales2 !== void 0 ? _Sales$aShopSales2 : ' '
                }, "".concat(Sales).concat(index));
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                children: (_monthlySales$fullYea4 = monthlySales.fullYear.aShopSales) !== null && _monthlySales$fullYea4 !== void 0 ? _monthlySales$fullYea4 : ' '
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Table.Tr, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SmallTh, {
                children: "\u65B0\u898F\u51FA\u5E97\u6570"
              }), monthlySales.fH.map(function (Sales, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                  children: Sales.allShops === 0 ? ' ' : Sales.newOpenShops
                }, "".concat(Sales).concat(index));
              }), monthlySales.sH.map(function (Sales, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                  children: Sales.allShops === 0 ? ' ' : Sales.newOpenShops
                }, "".concat(Sales).concat(index));
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                children: monthlySales.fullYear.allShops === 0 ? ' ' : monthlySales.fullYear.newOpenShops
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Table.Tr, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SmallTh, {
                children: "\u9589\u5E97\u5E97\u8217\u6570"
              }), monthlySales.fH.map(function (Sales, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                  children: Sales.allShops === 0 ? ' ' : Sales.closeShops
                }, "".concat(Sales).concat(index));
              }), monthlySales.sH.map(function (Sales, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                  children: Sales.allShops === 0 ? ' ' : Sales.closeShops
                }, "".concat(Sales).concat(index));
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                children: monthlySales.fullYear.allShops === 0 ? ' ' : monthlySales.fullYear.closeShops
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Table.Tr, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SmallTh, {
                children: "\u5168\u5E97\u8217\u6570"
              }), monthlySales.fH.map(function (Sales, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                  children: Sales.allShops === 0 ? ' ' : Sales.allShops
                }, "".concat(Sales).concat(index));
              }), monthlySales.sH.map(function (Sales, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                  children: Sales.allShops === 0 ? ' ' : Sales.allShops
                }, "".concat(Sales).concat(index));
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                children: monthlySales.fullYear.allShops === 0 ? ' ' : monthlySales.fullYear.allShops
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Table.Tr, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Table.Th, {
                rowSpan: 9,
                noBorder: true,
                style: {
                  whiteSpace: 'nowrap'
                },
                children: ["\u897F", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u53CB"]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Table.Th, {
                rowSpan: 3,
                style: {
                  whiteSpace: 'nowrap'
                },
                children: ["\u65E2", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u5B58", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u5E97"]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTh, {
                children: "\u58F2\u4E0A\u9AD8"
              }), monthlySales.fH.map(function (Sales, index) {
                var _Sales$seiyuOShopSale;

                return /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                  children: (_Sales$seiyuOShopSale = Sales.seiyuOShopSales) !== null && _Sales$seiyuOShopSale !== void 0 ? _Sales$seiyuOShopSale : ' '
                }, "".concat(Sales).concat(index));
              }), monthlySales.sH.map(function (Sales, index) {
                var _Sales$seiyuOShopSale2;

                return /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                  children: (_Sales$seiyuOShopSale2 = Sales.seiyuOShopSales) !== null && _Sales$seiyuOShopSale2 !== void 0 ? _Sales$seiyuOShopSale2 : ' '
                }, "".concat(Sales).concat(index));
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                children: (_monthlySales$fullYea5 = monthlySales.fullYear.seiyuOShopSales) !== null && _monthlySales$fullYea5 !== void 0 ? _monthlySales$fullYea5 : ' '
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Table.Tr, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SmallTh, {
                children: "\u5BA2\u6570"
              }), monthlySales.fH.map(function (Sales, index) {
                var _Sales$seiyuOShopCust;

                return /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                  children: (_Sales$seiyuOShopCust = Sales.seiyuOShopCustomers) !== null && _Sales$seiyuOShopCust !== void 0 ? _Sales$seiyuOShopCust : ' '
                }, "".concat(Sales).concat(index));
              }), monthlySales.sH.map(function (Sales, index) {
                var _Sales$seiyuOShopCust2;

                return /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                  children: (_Sales$seiyuOShopCust2 = Sales.seiyuOShopCustomers) !== null && _Sales$seiyuOShopCust2 !== void 0 ? _Sales$seiyuOShopCust2 : ' '
                }, "".concat(Sales).concat(index));
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                children: (_monthlySales$fullYea6 = monthlySales.fullYear.seiyuOShopCustomers) !== null && _monthlySales$fullYea6 !== void 0 ? _monthlySales$fullYea6 : ' '
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Table.Tr, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SmallTh, {
                children: "\u5BA2\u5358\u4FA1"
              }), monthlySales.fH.map(function (Sales, index) {
                var _Sales$seiyuOShopCust3;

                return /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                  children: (_Sales$seiyuOShopCust3 = Sales.seiyuOShopCustomerUnitPrice) !== null && _Sales$seiyuOShopCust3 !== void 0 ? _Sales$seiyuOShopCust3 : ' '
                }, "".concat(Sales).concat(index));
              }), monthlySales.sH.map(function (Sales, index) {
                var _Sales$seiyuOShopCust4;

                return /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                  children: (_Sales$seiyuOShopCust4 = Sales.seiyuOShopCustomerUnitPrice) !== null && _Sales$seiyuOShopCust4 !== void 0 ? _Sales$seiyuOShopCust4 : ' '
                }, "".concat(Sales).concat(index));
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                children: (_monthlySales$fullYea7 = monthlySales.fullYear.seiyuOShopCustomerUnitPrice) !== null && _monthlySales$fullYea7 !== void 0 ? _monthlySales$fullYea7 : ' '
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Table.Tr, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Table.Th, {
                rowSpan: 6,
                style: {
                  whiteSpace: 'nowrap'
                },
                children: ["\u5168", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u5E97"]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTh, {
                children: "\u58F2\u4E0A\u9AD8"
              }), monthlySales.fH.map(function (Sales, index) {
                var _Sales$seiyuAShopSale;

                return /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                  children: (_Sales$seiyuAShopSale = Sales.seiyuAShopSales) !== null && _Sales$seiyuAShopSale !== void 0 ? _Sales$seiyuAShopSale : ' '
                }, "".concat(Sales).concat(index));
              }), monthlySales.sH.map(function (Sales, index) {
                var _Sales$seiyuAShopSale2;

                return /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                  children: (_Sales$seiyuAShopSale2 = Sales.seiyuAShopSales) !== null && _Sales$seiyuAShopSale2 !== void 0 ? _Sales$seiyuAShopSale2 : ' '
                }, "".concat(Sales).concat(index));
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                children: (_monthlySales$fullYea8 = monthlySales.fullYear.seiyuAShopSales) !== null && _monthlySales$fullYea8 !== void 0 ? _monthlySales$fullYea8 : ' '
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Table.Tr, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SmallTh, {
                children: "\u65B0\u898F\u51FA\u5E97\u6570"
              }), monthlySales.fH.map(function (Sales, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                  children: Sales.seiyuAllShops === 0 ? ' ' : Sales.seiyuNewOpenShops
                }, "".concat(Sales).concat(index));
              }), monthlySales.sH.map(function (Sales, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                  children: Sales.seiyuAllShops === 0 ? ' ' : Sales.seiyuNewOpenShops
                }, "".concat(Sales).concat(index));
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                children: monthlySales.fullYear.seiyuAllShops === 0 ? ' ' : monthlySales.fullYear.seiyuNewOpenShops
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Table.Tr, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SmallTh, {
                children: "\u9589\u5E97\u5E97\u8217\u6570"
              }), monthlySales.fH.map(function (Sales, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                  children: Sales.seiyuAllShops === 0 ? ' ' : Sales.seiyuCloseShops
                }, "".concat(Sales).concat(index));
              }), monthlySales.sH.map(function (Sales, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                  children: Sales.seiyuAllShops === 0 ? ' ' : Sales.seiyuCloseShops
                }, "".concat(Sales).concat(index));
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                children: monthlySales.fullYear.seiyuAllShops === 0 ? ' ' : monthlySales.fullYear.seiyuCloseShops
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Table.Tr, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SmallTh, {
                children: "\u5168\u5E97\u8217\u6570"
              }), monthlySales.fH.map(function (Sales, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                  children: Sales.seiyuAllShops === 0 ? ' ' : Sales.seiyuAllShops
                }, "".concat(Sales).concat(index));
              }), monthlySales.sH.map(function (Sales, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                  children: Sales.seiyuAllShops === 0 ? ' ' : Sales.seiyuAllShops
                }, "".concat(Sales).concat(index));
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                children: monthlySales.fullYear.seiyuAllShops === 0 ? ' ' : monthlySales.fullYear.seiyuAllShops
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Table.Tr, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SmallTh, {
                children: ["\u696D\u614B\u8EE2\u63DB\u6570", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "(\u897F\u53CB\u21D2", (0,useMediaQuery/* useMediaQuery */.a)('(max-width: 1047px)') ? /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}) : '', "\u30C8\u30E9\u30A4\u30A2\u30EB\u897F\u53CB)"]
              }), monthlySales.fH.map(function (Sales, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                  children: Sales.seiyuAllShops === 0 ? ' ' : Sales.seiyuToTrial
                }, "".concat(Sales).concat(index));
              }), monthlySales.sH.map(function (Sales, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                  children: Sales.seiyuAllShops === 0 ? ' ' : Sales.seiyuToTrial
                }, "".concat(Sales).concat(index));
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTd, {
                children: monthlySales.fullYear.seiyuAllShops === 0 ? ' ' : monthlySales.fullYear.seiyuToTrial
              })]
            })]
          })]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 15,
        pc: 20
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
      children: "* \u58F2\u4E0A\u9AD8\u306E\u524D\u5E74\u540C\u6708\u6BD4\u306FPOS\u30C7\u30FC\u30BF\u306B\u57FA\u3065\u3044\u305F\u901F\u5831\u5024\u3067\u3042\u308A\u3001\u6C7A\u7B97\u6570\u5024\u3068\u7570\u306A\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
      children: "*\u300C\u30B0\u30ED\u30B5\u30EA\u30FC\u300D\u306F\u83D3\u5B50\u985E\u306A\u3069\u306E\u52A0\u5DE5\u98DF\u54C1\u3001\u300C\u30C7\u30A4\u30EA\u30FC\u300D\u306F\u5375\u3084\u4E73\u88FD\u54C1\u306A\u3069\u306E\u65E5\u914D\u54C1\u3001\u300C\u30D5\u30EC\u30C3\u30B7\u30E5\u300D\u306F\u751F\u9BAE\u56DB\u54C1(\u9752\u679C\uFF65\u7CBE\u8089\uFF65\u9BAE\u9B5A\uFF65\u60E3\u83DC)\u3001\u300C\u751F\u6D3B\u300D\u306F\u65E5\u7528\u6D88\u8017\u54C1\u306A\u3069\u306E\u5BB6\u5EAD\u7528\u54C1\u3001\u300C\u30CF\u30FC\u30C9\u300D\u306F\u5BB6\u96FB\u88FD\u54C1\u306A\u3069\u306E\u8010\u4E45\u6027\u5546\u54C1\u3001\u300C\u30A2\u30D1\u30EC\u30EB\u300D\u306F\u8863\u6599\u54C1\u3092\u793A\u3057\u3066\u304A\u308A\u307E\u3059\u3002"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
      children: "*\u300C\u30C8\u30E9\u30A4\u30A2\u30EB\u897F\u53CB\u300D\u3078\u306E\u696D\u614B\u8EE2\u63DB\u5E97\u306F\u3001\u897F\u53CB\u306E\u5E97\u8217\u3068\u3057\u3066\u96C6\u8A08\u3057\u3066\u304A\u308A\u3001\u897F\u53CB\u306E\u5408\u8A08\u5E97\u8217\u6570\u306B\u5897\u6E1B\u306F\u3042\u308A\u307E\u305B\u3093\u3002"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 30,
        pc: 80
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SubHeading, {
        children: "\u6982\u6CC1\u30B3\u30E1\u30F3\u30C8"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 20,
          pc: 36
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: monthlySales.summary.split('→').map(function (value, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
            children: [value, /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})]
          }, "".concat(index).concat(value));
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 15,
          pc: 30
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Annotation */.q, {
        children: monthlySales.comments.split('→').map(function (value, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
            children: [value, /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})]
          }, "".concat(index).concat(value));
        })
      })]
    })]
  });
};
var SubHeading = (0,styled_components_browser_esm/* default */.ZP)(Heading/* BHeading */.Zg).withConfig({
  displayName: "Table__SubHeading",
  componentId: "sc-9263qh-0"
})(["margin-top:0;margin-bottom:0;"]);
var PublicationDate = (0,styled_components_browser_esm/* default */.ZP)(ChartAnnotation/* ChartAnnotation */.z).withConfig({
  displayName: "Table__PublicationDate",
  componentId: "sc-9263qh-1"
})(["text-align:right;"]);
var SmallTd = (0,styled_components_browser_esm/* default */.ZP)(Table.Td).withConfig({
  displayName: "Table__SmallTd",
  componentId: "sc-9263qh-2"
})(["padding:11px 5px 14px 5px;&:nth-of-type(4),&:nth-of-type(8),&:nth-of-type(13),&:nth-of-type(17){min-width:48px;background:", ";}&:nth-of-type(9),&:nth-of-type(18),&:nth-of-type(19){background:", ";}"], theme/* theme.colors.th.tertiary */.r.colors.th.tertiary, theme/* theme.colors.th.secondary */.r.colors.th.secondary);
var SmallTh = (0,styled_components_browser_esm/* default */.ZP)(Table.Th).withConfig({
  displayName: "Table__SmallTh",
  componentId: "sc-9263qh-3"
})(["width:85px;padding:11px 9px 14px 9px;white-space:nowrap;"]);
var QuarterTh = (0,styled_components_browser_esm/* default */.ZP)(Table.Th).withConfig({
  displayName: "Table__QuarterTh",
  componentId: "sc-9263qh-4"
})(["min-width:48px;"]);
// EXTERNAL MODULE: ./src/components/elements/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(70770);
// EXTERNAL MODULE: ./src/components/layout.tsx + 7 modules
var layout = __webpack_require__(55548);
// EXTERNAL MODULE: ./src/components/layouts/Head/index.tsx
var Head = __webpack_require__(22978);
// EXTERNAL MODULE: ./src/components/layouts/Ir/index.tsx
var Ir = __webpack_require__(87661);
;// CONCATENATED MODULE: ./src/components/pages/Ir/Financial/MonthlySales/index.tsx










var MonthlySalesPage = function MonthlySalesPage(_ref) {
  var monthlySales = _ref.monthlySales,
      yearsPdf = _ref.yearsPdf;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Ir/* Layout */.A, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
      titleText: "Monthly Sales Report",
      subTitleText: "\u6708\u6B21\u58F2\u4E0A\u9AD8\u901F\u5831",
      color: "normal"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 70,
        pc: 120
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(MonthlySalesTable, {
      monthlySales: monthlySales
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 80,
        pc: 100
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(MonthlySalesPDF, {
      yearsPdf: yearsPdf
    })]
  });
};

MonthlySalesPage.getLayout = function (page) {
  var breadCrumbs = [{
    name: 'ホーム',
    path: '/'
  }, {
    name: '株主・投資家向け情報',
    path: '/ir'
  }, {
    name: '業績・財務情報',
    path: '/ir/financial/'
  }, {
    name: '月次売上高速報',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "\u6708\u6B21\u58F2\u4E0A\u9AD8\u901F\u5831",
      description: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u30B0\u30EB\u30FC\u30D7\u55B6\u696D\u5E97\u8217\u306B\u304A\u3051\u308B\u6708\u6B21\u58F2\u4E0A\u9AD8\u901F\u5831\u306B\u3064\u3044\u3066\u63B2\u8F09\u3057\u3066\u3044\u307E\u3059\u3002",
      ogp: {
        url: 'ir/financial/monthly-Sales'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(layout/* TitleLayout */.$0, {
      title: "Investor Relations",
      subTitle: "\u682A\u4E3B\u30FB\u6295\u8CC7\u5BB6\u5411\u3051\u60C5\u5831",
      breadCrumbs: breadCrumbs,
      children: page
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/ir/financial/monthly-sales.tsx
var __N_SSG = true;


/***/ }),

/***/ 16645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bp": function() { return /* binding */ isEqualYear; },
/* harmony export */   "dG": function() { return /* binding */ isEqualMonth; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72167);

var formatDate = function formatDate(date, formatType) {
  try {
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(new Date(date), formatType);
  } catch (e) {
    return date;
  }
};
var isEqualYear = function isEqualYear(date, year) {
  return formatDate(date, 'yyyy') === year;
};
var isEqualMonth = function isEqualMonth(date, month) {
  return formatDate(date, 'M') === month;
};

/***/ }),

/***/ 11049:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ir/financial/monthly-sales",
      function () {
        return __webpack_require__(777);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,2167,5548,4535,9774,2888,179], function() { return __webpack_exec__(11049); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);